// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const CloudProvider = {
  CloudProviderAWS: 'aws',
  CloudProviderAzure: 'azure',
  CloudProviderGCP: 'gcp',
} as const;
export type CloudProvider = (typeof CloudProvider)[keyof typeof CloudProvider];

export function instanceOfCloudProvider(value: any): boolean {
  for (const key in CloudProvider) {
    if (Object.prototype.hasOwnProperty.call(CloudProvider, key)) {
      if (CloudProvider[key as keyof typeof CloudProvider] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CloudProviderFromJSON(json: any): CloudProvider {
  return CloudProviderFromJSONTyped(json, false);
}

export function CloudProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CloudProvider {
  return json as CloudProvider;
}

export function CloudProviderToJSON(value?: CloudProvider | null): any {
  return value as any;
}

export function CloudProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CloudProvider {
  return value as CloudProvider;
}
